import React, { useState } from "react";

const Message = ({ variant, children }) => {
  const [open, setOpen] = useState(true);

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(!open);
  };

  if (open) {
    return (
      <div className={`${variant} message d-flex align-items-center text-white`}>
        <div className="pr-1">{children}</div>
        <button onClick={handleClick}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default Message;
